<template>
  <div class="custom-loading-wrapper">
    <div class="custom-loading">
      <div class="bg-primary rect1"></div>
      <div class="bg-primary rect2"></div>
      <div class="bg-primary rect3"></div>
      <div class="bg-primary rect4"></div>
      <div class="bg-primary rect5"></div>
    </div>
  </div>
</template>
<style scoped>
.custom-loading-wrapper {
    position: relative;
    height: 250px;
    display: flex;
}
.custom-loading {
    margin: 0px auto;
    width: 50px;
    height: 40px;
    text-align: center;
    font-size: 10px;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    left: 0;
    right: 0;
}

.custom-loading > div {
  margin: 0 1px;
  background-color: #37b544;
  height: 100%;
  width: 6px;
  display: inline-block;
  
  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.custom-loading .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.custom-loading .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.custom-loading .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.custom-loading .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }  
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% { 
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% { 
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}
</style>